import { BillingDetails, Subscription } from "../billing";
import { DesignSystem } from "../dsm/design-system";
import { ForgeDefaultProjectRole, ForgeProjectAccessMode } from "../forge";
import { nullishToOptional, } from "../helpers";
import { NpmRegistryConfig } from "./npm-registry-settings";
import { SsoProvider } from "./sso-provider";
import IPCIDR from "ip-cidr";
import { z } from "zod";
const isValidCIDR = (value) => {
    return IPCIDR.isValidAddress(value);
};
export const WorkspaceDefaultProjectAccessMode = ForgeProjectAccessMode;
export const WorkspaceDefaultProjectRole = ForgeDefaultProjectRole;
export const WorkspaceIpWhitelistEntry = z.object({
    isEnabled: z.boolean(),
    name: z.string(),
    range: z.string().refine(isValidCIDR, {
        message: "Invalid IP CIDR",
    }),
});
export const WorkspaceIpSettings = z.object({
    isEnabledForCloud: z.boolean(),
    isEnabledForDocs: z.boolean(),
    entries: z.array(WorkspaceIpWhitelistEntry),
});
export const WorkspaceProfile = z.object({
    name: z.string(),
    handle: z.string(),
    color: z.string(),
    avatar: nullishToOptional(z.string()),
    billingDetails: nullishToOptional(BillingDetails),
});
export const WorkspaceProfileUpdate = WorkspaceProfile.omit({
    avatar: true,
});
export const Workspace = z.object({
    id: z.string(),
    profile: WorkspaceProfile,
    subscription: Subscription,
    ipWhitelist: nullishToOptional(WorkspaceIpSettings),
    sso: nullishToOptional(SsoProvider),
    npmRegistrySettings: nullishToOptional(NpmRegistryConfig),
    aiFeaturesEnabled: z.boolean().default(false),
    projectsEnabled: z.boolean().default(false),
    defaultProjectAccessMode: WorkspaceDefaultProjectAccessMode,
    defaultProjectRole: WorkspaceDefaultProjectRole,
    aiAskFeaturesEnabled: z.boolean().default(false),
    aiCustomInstruction: z.string().optional(),
    hasOpenMeterSubject: z.boolean(),
});
export const WorkspaceWithDesignSystems = z.object({
    workspace: Workspace,
    designSystems: z.array(DesignSystem),
});
